import { template as template_a02cbaacbdc4473ea224805494bb0d0f } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
/**
  @class TBodyCell

  Renders a `<td>` element (if its corresponding column definition has `@visible={{true}}`).
  ```hbs
  <row.cell>
    {{person.firstName}}
  </row.cell>

  If the prop name was used when the column header was defined, it is yielded in a hash
  ```hbs
  <row.cell as |column|>
    {{get person column.prop}}
  </row.cell>
  ```
*/ import { hash } from '@ember/helper';
export default class TBodyCell extends Component {
    static{
        template_a02cbaacbdc4473ea224805494bb0d0f(`
    {{#if this.column.visible}}
      <td class='{{@class}} {{this.column.columnClass}} {{@theme.tbodyCell}}' ...attributes>
        {{yield (hash prop=this.column.prop)}}
      </td>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @tracked
    index;
    get column() {
        return this.args.columns[this.index] || {};
    }
    constructor(){
        super(...arguments);
        this.index = this.args.parent?.registerCell(this);
    }
    willDestroy() {
        super.willDestroy(...arguments);
        this.args.parent?.unregisterCell(this);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3Rib2R5L3Jvdy9jZWxsLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5pbXBvcnQgeyB0cmFja2VkIH0gZnJvbSAnQGdsaW1tZXIvdHJhY2tpbmcnO1xuXG4vKipcbiAgQGNsYXNzIFRCb2R5Q2VsbFxuXG4gIFJlbmRlcnMgYSBgPHRkPmAgZWxlbWVudCAoaWYgaXRzIGNvcnJlc3BvbmRpbmcgY29sdW1uIGRlZmluaXRpb24gaGFzIGBAdmlzaWJsZT17e3RydWV9fWApLlxuICBgYGBoYnNcbiAgPHJvdy5jZWxsPlxuICAgIHt7cGVyc29uLmZpcnN0TmFtZX19XG4gIDwvcm93LmNlbGw-XG5cbiAgSWYgdGhlIHByb3AgbmFtZSB3YXMgdXNlZCB3aGVuIHRoZSBjb2x1bW4gaGVhZGVyIHdhcyBkZWZpbmVkLCBpdCBpcyB5aWVsZGVkIGluIGEgaGFzaFxuICBgYGBoYnNcbiAgPHJvdy5jZWxsIGFzIHxjb2x1bW58PlxuICAgIHt7Z2V0IHBlcnNvbiBjb2x1bW4ucHJvcH19XG4gIDwvcm93LmNlbGw-XG4gIGBgYFxuKi9cblxuaW1wb3J0IHsgaGFzaCB9IGZyb20gJ0BlbWJlci9oZWxwZXInO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBUQm9keUNlbGwgZXh0ZW5kcyBDb21wb25lbnQge1xuICA8dGVtcGxhdGU-XG4gICAge3sjaWYgdGhpcy5jb2x1bW4udmlzaWJsZX19XG4gICAgICA8dGQgY2xhc3M9J3t7QGNsYXNzfX0ge3t0aGlzLmNvbHVtbi5jb2x1bW5DbGFzc319IHt7QHRoZW1lLnRib2R5Q2VsbH19JyAuLi5hdHRyaWJ1dGVzPlxuICAgICAgICB7e3lpZWxkIChoYXNoIHByb3A9dGhpcy5jb2x1bW4ucHJvcCl9fVxuICAgICAgPC90ZD5cbiAgICB7ey9pZn19XG4gIDwvdGVtcGxhdGU-XG5cbiAgQHRyYWNrZWRcbiAgaW5kZXg7XG5cbiAgZ2V0IGNvbHVtbigpIHtcbiAgICByZXR1cm4gdGhpcy5hcmdzLmNvbHVtbnNbdGhpcy5pbmRleF0gfHwge307XG4gIH1cblxuICBjb25zdHJ1Y3RvcigpIHtcbiAgICBzdXBlciguLi5hcmd1bWVudHMpO1xuICAgIHRoaXMuaW5kZXggPSB0aGlzLmFyZ3MucGFyZW50Py5yZWdpc3RlckNlbGwodGhpcyk7XG4gIH1cblxuICB3aWxsRGVzdHJveSgpIHtcbiAgICBzdXBlci53aWxsRGVzdHJveSguLi5hcmd1bWVudHMpO1xuICAgIHRoaXMuYXJncy5wYXJlbnQ_LnVucmVnaXN0ZXJDZWxsKHRoaXMpO1xuICB9XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxPQUFPLFFBQVEsb0JBQW9CO0FBRTVDOzs7Ozs7Ozs7Ozs7Ozs7QUFlQSxHQUVBLFNBQVMsSUFBSSxRQUFRLGdCQUFnQjtBQUVyQyxlQUFlLE1BQU0sa0JBQWtCO0lBQ3JDLE1BQUE7UUFBQSwwQ0FBVSxDQUFBOzs7Ozs7RUFNVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FOQTtJQVFWLENBQUM7SUFDRCxNQUFNO0lBRU4sSUFBSSxTQUFTO1FBQ1gsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztJQUMzQztJQUVBLGFBQWM7UUFDWixLQUFLLElBQUk7UUFDVCxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLGFBQWEsSUFBSTtJQUNsRDtJQUVBLGNBQWM7UUFDWixLQUFLLENBQUMsZUFBZTtRQUNyQixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxlQUFlLElBQUk7SUFDdkM7QUFDRiJ9